/* eslint-disable */
import { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import RoundButton from "../framework/forms/helpercomponents/buttons/RoundButton";
import MediaCard from "./MediaCard";
import * as API from "../framework/API/api";
import { useTranslation } from "../locale/useTranslation";
import AddRoundButton from "../framework/forms/helpercomponents/buttons/AddRoundButton";
import { ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, RAIL_STATUS, TOAST_TYPES } from "../framework/constant/constant";
import { RailsCardList } from "../framework/OTT/Component/RailsCustomCard";
import { utility } from "../framework/utility/utilityProvider";
import PreferenceRoundButton from "../framework/forms/helpercomponents/buttons/PreferenceRoundButton";
import { UserPreference } from "../modules/userPreference/UserPreference";
import CardListGridView from "./CardListGridView";
import { useRef } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Loader } from "../framework/forms/helpercomponents/Loader";
import ToastNotification from "./ToastNotification";

export const CardList = (props) => {

  const { title, onAddClick, onIngestClick, showSearch, cardData, close, containerName, onDragEnter, entityName, customCard, inTileView, showTileView, columnEntityName, onEditDataItem, selectedIconColor = { Mobile: true, TV: true, Web: true, Tab: true }, setSelectedIconColor = () => { }, showDeleteAll = false, onDeleteAllData, customColumns = [], showEdit = true, showDelete = false, onDeleteDataItem, onLinkClick, shortBy = "_id", isLoading = false, source = {} } = props;

  let showPreferenceButton = props.showPreferenceButton ?? false;
  let showEpisodeArchiveCheckbox = props.showEpisodeArchiveCheckbox ?? false;
  let showExport = props.showExport ?? false;
  let showMultiVersioning = props.showMultiVersioning ?? false
  let showMultiSelect = props.showMultiSelect ?? false;
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const isOutdoor = (company?.Name ?? "") == "Outdoor";

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedState, setSelectedState] = useState({}); // for multi select
  const [selectedData, setSelectedData] = useState([]);
  const [showUpdateMultiple, setShowUpdateMultiple] = useState(false);
  const [showMultiVersionPopup, setShowMutliVersionPopup] = useState(false);
  const [data, setData] = useState([]);
  const [orginalData, setOrginalData] = useState([]); // for search
  const [isMoredata, setIsMoredata] = useState(true);
  const [dataColumns, setDataColumns] = useState([]);
  const [tileView, setTileView] = useState(inTileView); //true to show tile
  const [showPreferences, setShowPreferences] = useState(false);
  const [selectAll, setSelectAll] = useState(data.length != selectedData.length ? true : false);
  const [railsStatusItem, setRailsStatusItem] = useState({
    _id: 0,
    Description: "All"
  });

  const lang = useTranslation();
  //Export Excel
  const _export = useRef(null);

  const hasFetchedRef = useRef(false);
  const finalDataRef = useRef([]);

  // load initial data
  useEffect(() => {
    if (cardData?.length > 0) {
      setData(cardData);
      setOrginalData(cardData);
      setIsMoredata(false);
      return;
    }

    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    loadDataIntialData();
  }, [cardData]);

  // load columns
  useEffect(() => {
    loadColums();
  }, []);

  // load data
  useEffect(() => {
    if (currentPage > 1 && (!cardData || cardData.length === 0)) {
      loadData();
    }
  }, [currentPage]);

  const loadColums = async () => {
    if (customColumns && customColumns.length > 0) {
      setDataColumns(customColumns);
      return;
    }
    let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
    let columns = await API.getFormData(columnEntityName, currentUserId);
    setDataColumns(columns ?? []);
  };

  let final_data_rail = [];

  const loadDataIntialData = async () => {

    let res = {};

    if (entityName == ENTITYNAME.Rails) {
      let columns = await API.getFormData(
        ENTITYNAME.Rails,
        utility.getValue(LOCALSTORAGE_KEY.user_id)
      );

      res = await API.getRailsWithCampaign(
        {
          query: ["Archive", "=", false],
          page: currentPage,
          perPage: 200,
          archive: false,
          sort: { SID: 1 },
        },
        columns,
        '',
        RAIL_STATUS.Active
      );

    }
    if (Object.keys(res).length == 0) {
      return;
    }
    if (res.success) {

      let final_data_rail = [];

      if (entityName == ENTITYNAME.Rails) {

        let ott_types = await API.getDataLookup(ENTITYNAME.OttRailType);
        let ott_Platform_Types = await API.getDataLookup(ENTITYNAME.Platform);

        const ottMap = new Map(ott_types.data.map(i => [i.SID, i]));
        const platformMap = new Map(ott_Platform_Types.data.map(i => [i.SID, i]));

        final_data_rail = res.data.map((item) => {
          const ott = ottMap.get(item.OttRailTypeSID);

          return {
            ...item,
            PotraitImageUrl: ott?.Icon,
            RailType: ott?.Description,
            PlatformTypes: item.PlatformSIDs?.map(id => platformMap.get(id)).filter(Boolean)
          };
        });

        final_data_rail = utility.getDataWithDisplayValueByLang(
          final_data_rail,
          ['Title', 'DisplayTitle'],
          props.selectedLanguage
        );

      } else {
        final_data_rail = res.data;
      }

      finalDataRef.current = final_data_rail;

      setData(final_data_rail);
      setOrginalData(final_data_rail);

    } else {
      ToastNotification({ message: res.message });
    }
  };

  const onCloseUserPrefence = () => {
    loadColums();
    loadDataIntialData();
    setShowPreferences(!showPreferences);
  }

  const loadData = async () => {
    if (cardData) return;

    let res = await API.getData(entityName, {
      pagination: {
        per_page: 10,
        current_page: currentPage,
        orderby: shortBy,
        direction: "asc",
      },
    });

    if (res.success) {
      setData((old) => [...old, ...res.data]);
      setOrginalData((old) => [...old, ...res.data]);
      setIsMoredata(orginalData.length < res.pagination.total);
    }
  };

  const onChangeArchiveMediaEpisode = async () => {
    const newValue = !props.archiveEpisode;
    props.setArchiveEpisode(newValue);
    let responseMediaEpisode = await props.loadEpisodes(undefined, newValue);
    setData(responseMediaEpisode);
  };

  const fetchMoreData = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const setHoveredDataItemPostion = (index, dataItem) => {
    //if index  -1 means we need to add card at last
    setSelectedIndex((ind) => (index == -1 ? data.length - 1 : index));
  };

  let defaultKeys = [];
  const onSearch = (e) => {

    const keyword = e.target.value?.trim();
    let datakey = Object.keys(orginalData[0]);
    datakey.map((key) => {
      if (key == "Title" && !defaultKeys.includes(key)) {
        defaultKeys.push(key);
      }
      else if (key == "Name" && !defaultKeys.includes(key)) {
        defaultKeys.push(key);
      }
      else if (key == "AssetId" && !defaultKeys.includes(key)) {
        defaultKeys.push(key);
      }
      else if (key == "ReferenceCode" && !defaultKeys.includes(key)) {
        defaultKeys.push(key);
      }
    });
    let dataStore = [];
    if (keyword != "") {
      defaultKeys.map((item) => {
        var filterData = orginalData.filter((obj) => obj[item] && obj[item].toLowerCase().includes(keyword?.toLowerCase()));
        if (filterData.length != 0) {
          dataStore.push(...filterData);
        }
      });
      const uniqData = [...new Set(dataStore)];
      handleRailStatusChange({ target: { value: railsStatusItem } }, uniqData)
    } else {
      handleRailStatusChange({ target: { value: railsStatusItem } }, orginalData)
      // If the text field is empty, show all users
    }
  };

  const onSelection = (index, dataItem) => {
    let copyData = [...data];
    resetSelection(copyData);
    copyData[index] = { ...Object.assign(dataItem, { isSelected: true }) };
    setData(copyData);
  };

  const resetSelection = (copyData) => {
    copyData.map((dataItem) => {
      Object.assign(dataItem, { isSelected: false });
    });
  };

  const onFilterIconClick = (type) => {
    let filterData = [];

    setSelectedIconColor({ ...selectedIconColor, [type]: !selectedIconColor[type] })

    if (type == "Mobile") {
      if (selectedIconColor.Mobile) {
        filterData = [
          ...orginalData.filter((x) => selectedIconColor.TV && x.PlatformSIDs?.includes('2')),
          ...orginalData.filter((x) => selectedIconColor.Web && x.PlatformSIDs?.includes('3')),
          ...orginalData.filter((x) => selectedIconColor.Tab && x.PlatformSIDs?.includes('4'))
        ]
      } else {
        filterData = [
          ...orginalData.filter((x) => x.PlatformSIDs?.includes('1')),
          ...orginalData.filter((x) => selectedIconColor.TV && x.PlatformSIDs?.includes('2')),
          ...orginalData.filter((x) => selectedIconColor.Web && x.PlatformSIDs?.includes('3')),
          ...orginalData.filter((x) => selectedIconColor.Tab && x.PlatformSIDs?.includes('4'))
        ]
      }
    } else if (type == 'TV') {
      if (selectedIconColor.TV) {
        filterData = [
          ...orginalData.filter((x) => selectedIconColor.Mobile && x.PlatformSIDs?.includes('1')),
          ...orginalData.filter((x) => selectedIconColor.Web && x.PlatformSIDs?.includes('3')),
          ...orginalData.filter((x) => selectedIconColor.Tab && x.PlatformSIDs?.includes('4'))
        ]
      } else {
        filterData = [
          ...orginalData.filter((x) => x.PlatformSIDs?.includes('2')),
          ...orginalData.filter((x) => selectedIconColor.Mobile && x.PlatformSIDs?.includes('1')),
          ...orginalData.filter((x) => selectedIconColor.Web && x.PlatformSIDs?.includes('3')),
          ...orginalData.filter((x) => selectedIconColor.Tab && x.PlatformSIDs?.includes('4')),
        ]
      }
    } else if (type == 'Web') {
      if (selectedIconColor.Web) {
        filterData = [
          ...orginalData.filter((x) => selectedIconColor.Mobile && x.PlatformSIDs?.includes('1')),
          ...orginalData.filter((x) => selectedIconColor.TV && x.PlatformSIDs?.includes('2')),
          ...orginalData.filter((x) => selectedIconColor.Tab && x.PlatformSIDs?.includes('4')),
        ]
      } else {
        filterData = [
          ...orginalData.filter((x) => x.PlatformSIDs?.includes('3')),
          ...orginalData.filter((x) => selectedIconColor.Mobile && x.PlatformSIDs?.includes('1')),
          ...orginalData.filter((x) => selectedIconColor.TV && x.PlatformSIDs?.includes('2')),
          ...orginalData.filter((x) => selectedIconColor.Tab && x.PlatformSIDs?.includes('4')),
        ]
      }
    } else if (type == 'Tab') {
      if (selectedIconColor.Tab) {
        filterData = [
          ...orginalData.filter((x) => selectedIconColor.Mobile && x.PlatformSIDs?.includes('1')),
          ...orginalData.filter((x) => selectedIconColor.TV && x.PlatformSIDs?.includes('2')),
          ...orginalData.filter((x) => selectedIconColor.Web && x.PlatformSIDs?.includes('3')),
        ]
      } else {
        filterData = [
          ...orginalData.filter((x) => x.PlatformSIDs?.includes('4')),
          ...orginalData.filter((x) => selectedIconColor.Mobile && x.PlatformSIDs?.includes('1')),
          ...orginalData.filter((x) => selectedIconColor.TV && x.PlatformSIDs?.includes('2')),
          ...orginalData.filter((x) => selectedIconColor.Web && x.PlatformSIDs?.includes('3')),
        ]
      }
    } else {
      setSelectedIconColor({
        Mobile: true,
        TV: true,
        Web: true,
        Tab: true
      })
    }

    let data = [...new Set(filterData)];
    handleRailStatusChange({ target: { value: railsStatusItem } }, data);

  }

  const downloadMediaEpisodeReport = async () => {
    if (selectedData.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
      return;
    }

    let payload = {
      "mediaepisode": selectedData.map(item => item?._id?.toString() ?? item?._id)
    };

    let res = await API.getMediaEpisodeReport(payload);

    if (res.success) {
      window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message });
    }
  };

  const excelExport = async () => {
    if (data.length == 0) {
      return;
    }
    // if (isOutdoor) {
    //   await downloadMediaEpisodeReport();
    //   return;
    // }
    if (_export.current !== null) {
      _export.current.props.data.map(item => {
        item.Duration = item.Duration ? utility.convertMilisecondsToStringWithFrames(item.Duration) : '';
        item.modOn = item.modOn ? utility.convertMilisecondsToDateTimeString(item.modOn) : '';
        item.addOn = item.addOn ? utility.convertMilisecondsToDateTimeString(item.addOn) : '';
      })
      _export.current.save();
    }
  };

  const onSegmentationExport = async () => {
    if (_export.current !== null) {
      let payload = _export.current.props.data;
      var res = await API.getSegmentationDataExport(payload);
      if (res.success) {
        if (res.dataLength == 0) {
           ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_for_selected_filter_error_message });
          return;
        }
        else {
          window.open(FILEURL().BASEURL + 'downloadReport/' + res.fileName)
          ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_exported_export_template_message });
        }
      }
      else {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }
    }
  };


  const onUpdateMultiple = () => {
    setShowUpdateMultiple(true);
  }

  const onMultiVersioning = () => {

    if (selectedData.length == 0) {

      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_episodes_first });
      return;
    }

    setShowMutliVersionPopup(true);

  }

  const onSelectAllData = (e) => {
    let newSelectedState = {};

    if (e.target.checked && data.length > 0) {
      data.map((item) => {
        newSelectedState = { ...newSelectedState, [item._id]: true };
      });
      setSelectedData(data);
    } else {
      data.map((item) => {
        newSelectedState = { ...newSelectedState, [item._id]: false };
      });
      setSelectedData([]);
    }

    setSelectedState(newSelectedState);
    setSelectAll(e.target.checked);
  };


  const handleRailStatusChange = (e, data) => {
    let newData = [];
    if (e.target.value._id != RAIL_STATUS.All) {
      newData = data.filter((x) => x.IsActive == e.target.value._id)
    } else {
      newData = [...data]
    }

    setRailsStatusItem(e.target.value);
    setData(newData);
  }

  return (
    <div className={props.isWide ? "side-bar-items-30 marlr p-1" : "marlr p-1"}

      style={{ backgroundColor: "#EEEEEE", borderRadius: "10px" }}
    >
      <div className="row align-items-center">
        {title && <h3 className="col ml-1">{title}</h3>}

        {selectedData.length > 1 && !tileView && (
          <div className="col-1 icon-square" title={lang.update_multiple_title_button} onClick={onUpdateMultiple}>
            <i className="fas fa-pencil" />
          </div>
        )}

        {showMultiVersioning && !tileView && (
          <div className="col-1 icon-square ml-1" title={lang.export_segmentation_tooltip_button} onClick={onSegmentationExport}>
            <i className="fas fa-file-export" />
          </div>
        )}

        {showMultiVersioning && !tileView && (
          <div className="col-1 icon-square ml-1" title={lang.multi_versioning_tooltip_button} onClick={onMultiVersioning}>
            <i className="fas fa-layer-group" />
          </div>
        )}

        {showExport && !tileView && (
          <div className="col-1 icon-square ml-1" title={lang.export_excel_button_tooltip} onClick={excelExport}>
            <i className="fas fa-download" />
          </div>
        )}

        {showTileView && (
          <div
            className="col-1 icon-square ml-1"
            title={!tileView ? lang.title_view_tooltip_button : lang.close_title_view_tooltip_button}
            onClick={() => setTileView(!tileView)}
          >
            <i className={`fas ${tileView ? 'fa-table-cells' : 'fa-table-list'}`} />
          </div>
        )}

        {showDeleteAll && (
          <div className="col-1 icon-square ml-1" title={lang.delete_all_button_tooltip} onClick={onDeleteAllData}>
            <i className="fas fa-trash-alt" />
          </div>
        )}

        <div className="col-1 icon-square mr-2 ml-1" title={lang.close_button_tooltip} onClick={close}>
          <i className="fa fa-close" />
        </div>
      </div>
      <div className="flex-container">
        <div className="martb mar">
          {onAddClick && <AddRoundButton onClick={onAddClick} />}
          {onLinkClick && <RoundButton icon={"link"} title={"Link"} onClick={onLinkClick} />}
          {onIngestClick && <button
            title={lang.ingest_button_tooltip}
            type="button"
            onClick={onIngestClick}
            className="btn-square btn-success"
            style={{ marginLeft: "10px", minWidth: "100px", borderRadius: "5px" }}
          >
            {lang.ingest_button_text}
          </button>}
          {showPreferenceButton && <PreferenceRoundButton icon={"gear"} title={lang.preference_button_tooltip} onClick={() => { setShowPreferences(!showPreferences) }} />}
        </div>
        <div className="flex-container-reverse flex-item-auto">
          {showSearch && (
            <div className="input-group input-group w-300 ">
              <input
                type="text"
                className="form-control shadow-inset-2 pt-0 pb-0"
                id="filter-icon"
                aria-label="type 2 or more letters"
                placeholder={lang.search_by_title}
                onChange={onSearch}
              />
              <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                  </span>
                </div>
              </button>
            </div>
          )}
        </div>
      </div>
      {/* (props.title == 'Rails' || props.entityName == ENTITYNAME.Rails) */}
      {(props.title == 'Rails' || props.entityName == ENTITYNAME.Rails) && <div className="row p-1">
        <div className="col-5" style={{ paddingRight: '0px' }}>
          <DropDownList
            data={Object.keys(RAIL_STATUS).map((obj, index) => { return { _id: index, Description: obj } })}
            style={{
              backgroundColor: 'white',
            }}
            name="railsStatus"
            textField="Description"
            dataItemKey="_id"
            value={railsStatusItem}
            onChange={(e) => handleRailStatusChange(e, orginalData)}
          />

        </div>

        <div className="col-7" style={{ textAlign: 'right' }}>
          <RoundButton icon={"mobile"} title={"Moblie"} btnColor={selectedIconColor.Mobile ? 'warning' : 'white'} onClick={() => onFilterIconClick("Mobile")} />
          <RoundButton icon={"television"} title={"TV"} btnColor={selectedIconColor.TV ? 'warning' : 'white'} onClick={() => onFilterIconClick("TV")} />
          <RoundButton icon={"globe"} title={"Web"} btnColor={selectedIconColor.Web ? 'warning' : 'white'} onClick={() => onFilterIconClick("Web")} />
          <RoundButton icon={"tablet"} title={"Tablet"} btnColor={selectedIconColor.Tab ? 'warning' : 'white'} onClick={() => onFilterIconClick("Tab")} />
        </div></div>}
      <div>
        <div className="float-right">
          {showMultiSelect && <>
            <input name={"SelectAll"} type={"Checkbox"} value={selectAll} onChange={(e) => onSelectAllData(e)} checked={data.length == selectedData.length && selectAll}
              style={{ marginLeft: "10px", textAlign: "right", marginRight: "5px" }} />
            <label>{lang.select_all_label}</label>
          </>}
          {showEpisodeArchiveCheckbox && <>
            <input name={"Archive"} type={"Checkbox"} value={props.archiveEpisode} onChange={onChangeArchiveMediaEpisode} checked={props.archiveEpisode}
              style={{ marginLeft: "10px", textAlign: "right", marginRight: "5px" }} />
            <label>{lang.archive}</label>
          </>}
        </div>
        {showMultiSelect && showEpisodeArchiveCheckbox && <br />}
      </div>
      <div style={{ height: "2px" }} />

      <InfiniteScroll
        dataLength={data.length}
        next={fetchMoreData}
        hasMore={isMoredata}
      // loader={<h6>Loading...</h6>}
      // endMessage={<h6>All Loaded</h6>}
      >
        {isLoading ? <Loader /> : tileView ? <div
          id="MainCardContainer"
          style={{ height: showEpisodeArchiveCheckbox ? "68vh" : "68vh", overflowY: "auto", overflowX: "hidden", scrollbarWidth: "none" }}
          draggable
          onDragEnter={(e) => {
            if (e.target.id == "MainCardContainer") {
              setSelectedIndex((old) => e.target.children.length + 1);
            }
            onDragEnter(e, selectedIndex, containerName);
          }}
        >
          {
            data.map((dataItem, index) => {
              return (
                <>
                  {customCard ?
                    <RailsCardList
                      key={index}
                      index={index}
                      dataItem={dataItem}
                      {...props}
                      setHoveredDataItemPostion={setHoveredDataItemPostion}
                      onSelection={onSelection} /> :
                    <MediaCard
                      key={index}
                      index={index}
                      dataItem={dataItem}
                      {...props}
                      setHoveredDataItemPostion={setHoveredDataItemPostion}
                      onSelection={onSelection}
                    />
                  }</>
              );
            })}
        </div> : <CardListGridView source={source} shortBy={shortBy} data={data} setData={setData} _export={_export} dataColumns={dataColumns} onEditDataItem={onEditDataItem} onArchiveEpisodes={props.onArchiveEpisodes} archiveEpisode={props.archiveEpisode} enableSelection={props.enableSelection} showMultiVersioning={showMultiVersioning} selectedState={selectedState} setSelectedData={setSelectedData} showMultiVersionPopup={showMultiVersionPopup} setShowMutliVersionPopup={setShowMutliVersionPopup}
          showUpdateMultiple={showUpdateMultiple} setShowUpdateMultiple={setShowUpdateMultiple} loadEpisodes={props.loadEpisodes} showEdit={showEdit} showDelete={showDelete} onDeleteDataItem={onDeleteDataItem} />
        }
      </InfiniteScroll>
      {showPreferences && <UserPreference entityName={columnEntityName} preferenceColumnENntityName={columnEntityName} handleClose={onCloseUserPrefence} />}
      {cardData && cardData ? <div>{`${lang.total_label} ${cardData.length}`}</div> : final_data_rail.length > 0 ? <div>{`${lang.total_label} ${final_data_rail.length}`}</div> : <div>{`${lang.total_label} ${data.length}`}</div>}
    </div>
  );
};
